import axios from 'axios';

const API_URL = `${process.env.REACT_APP_API_BASE_URL}/audit`;

export async function fetchAuditLogs({ limit = 25, cursor, filters = {}, signal, loginHistory = false } = {}) {
  const params = { limit, cursor };
  for (const key of ['model', 'action', 'userEmail', 'userId', 'success', 'origin', 'from', 'to', 'search', 'requestId']) {
    if (filters[key] !== undefined && filters[key] !== null && filters[key] !== '') params[key] = filters[key];
  }
  const { data } = await axios.get(loginHistory ? `${API_URL}/logins` : API_URL, { params, signal });
  return data;
}

export async function fetchAuditFilters({ signal, loginHistory = false } = {}) {
  const { data } = await axios.get(`${API_URL}${loginHistory ? '/logins' : ''}/filters`, { signal });
  return data;
}

const auditService = { fetchAuditLogs, fetchAuditFilters };
export default auditService;
